
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindGrid, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const WareHouseMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [CityOptions, setCityOptions] = useState([]);
    const [Countrypre, setCountrypre] = useState("")
    const [CountryOption, setCountryOption] = useState([]);
    const [MenuText, setMenuText] = useState("Warehouse Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        WareHouseID: "0",
        WareHouseCode: "",
        WareHouseName: "",
        ContactPerson: "",
        PinCode: "",
        Country: "",
        CityName: "",
        EmailID: "",
        MobileNo: "",
        AddressLine1: "",
        AddressLine2: "",
        CashAccounts: "",
        Active: true
    });

    const handleClear = async () => {
        setSaveData({
            WareHouseID: "0",
            WareHouseCode: "",
            WareHouseName: "",
            ContactPerson: "",
            PinCode: "",
            Country: "",
            CityName: "",
            EmailID: "",
            MobileNo: "",
            AddressLine1: "",
            AddressLine2: "",
            CashAccounts: "",
            Active: true
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)

    }
    const [CashAccountsOptions, setCashAccountsOptions] = useState([]);
    useEffect(() => {
        setTitle('WareHouseMaster', setOpen);
        setFocus('txtWareHouseCode');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getWareHouseData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit = () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateWareHouseMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getWareHouseData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false);
            if (res.focus !== "") {
                setFocus(res.focus)
            }

        })
    }
    const getWareHouseData = (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExWareHouseMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'WareHouseMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            setIsLoading(false)
        })
    }
    const handleEditData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            Token, LoginUserCode: loginCodeString, WareHouseID: ID
        }
        post(`${API_SERVER}/api/Master/EditWareHouseMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    WareHouseID: ID,
                    WareHouseCode: editRecordJson[0]['WareHouseCode'],
                    WareHouseName: editRecordJson[0]['WareHouseName'],
                    ContactPerson: editRecordJson[0]['ContactPerson'],
                    PinCode: editRecordJson[0]['PinCode'],
                    Country: editRecordJson[0]['Country'],
                    CityName: editRecordJson[0]['CityName'],
                    EmailID: editRecordJson[0]['EmailID'],
                    MobileNo: editRecordJson[0]['MobileNo'],
                    AddressLine1: editRecordJson[0]['AddressLine1'],
                    AddressLine2: editRecordJson[0]['AddressLine2'],
                    CashAccounts: editRecordJson[0]['CashAccounts'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = (ID) => {
        const loginCodeString = String(LoginUserCode);

        setIsLoading(true)
        let data = {
            Token, LoginUserCode: loginCodeString, WareHouseID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteWareHouseMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                getWareHouseData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false);
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getWareHouseData();
    }
    const handleDownloadExcel = async () => {
        getWareHouseData('E');
    }
    const getCountry = () => {
        setCountryOption([]);
        let temp = {
            Type: "GetCountry",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CountryOptionData = res.autoCompleteData || [];
                setCountryOption(CountryOptionData);
            } else {
                setCountryOption([]);
            }
        });
    };
    const getCity = () => {
        setCityOptions([]);
        let temp = {
            Type: "GetCity",
            Prefix: "",
            ContextKey: Countrypre.split(':')[0].trim(),
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CityData = res.autoCompleteData || [];
                setCityOptions(CityData);
            } else {
                setCityOptions([]);
            }
        });
    };
    const getCashAccounts= () => {
        setCashAccountsOptions([]);
        let temp = {
            Type: "GetCashAccounts",
            Prefix: "",
            ContextKey: '',
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CashAccountsData = res.autoCompleteData || [];
                setCashAccountsOptions(CashAccountsData);
            } else {
                setCashAccountsOptions([]);
            }
        });
    };
    let CountryOptionArr = []
    for (let i = 0; i < CountryOption.length; i++) {
        let mydata = CountryOption[i]?.values
        CountryOptionArr.push(mydata)
    };
    let CityOptionArr = []
    for (let i = 0; i < CityOptions.length; i++) {
        let mydata = CityOptions[i]?.values
        CityOptionArr.push(mydata)
    };
    let CashAccountsOptionArr = []
    for (let i = 0; i < CashAccountsOptions.length; i++) {
        let mydata = CashAccountsOptions[i]?.values
        CashAccountsOptionArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">WareHouse Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.WareHouseID !== "0" ? true : false}
                                                type="text"
                                                maxLength="10"
                                                id="txtWareHouseCode"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtWareHouseName") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter WareHouse Code'
                                                value={SaveData.WareHouseCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, WareHouseCode: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">WareHouse Name<span className="Required">*</span></label>
                                            <input
                                                type="text"
                                                id="txtWareHouseName"
                                                maxLength="200"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtContactPerson") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter WareHouse Name'
                                                value={SaveData.WareHouseName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, WareHouseName: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Contact Person</label>
                                            <input
                                                id="txtContactPerson"

                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtPinCode") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Contact Person'
                                                value={SaveData.ContactPerson}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, ContactPerson: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">PinCode</label>
                                            <input
                                                id="txtPinCode"
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCountry") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter PinCode'
                                                value={SaveData.PinCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, PinCode: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCity") };
                                                }}
                                                label='Country'
                                                placeholder="Country"
                                                maxLength='50'
                                                options={CountryOptionArr}
                                                id='txtCountry'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCountry()}
                                                inputValue={SaveData.Country ? SaveData.Country : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({
                                                        ...SaveData, Country: newInputValue

                                                    })
                                                    setCountrypre(newInputValue)
                                                }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtEmailID") };
                                                }}
                                                label='City'
                                                placeholder="City"
                                                maxLength='50'
                                                options={CityOptionArr}
                                                id='txtCity'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCity()}
                                                inputValue={SaveData.CityName ? SaveData.CityName : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, CityName: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Email ID</label>
                                            <input
                                                id="txtEmailID"
                                                type="text"
                                                maxLength="50"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtMobileNo") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Email ID'
                                                value={SaveData.EmailID}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, EmailID: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Mobile No</label>
                                            <input
                                                id="txtMobileNo"
                                                type="text"
                                                maxLength="15"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtAddressLine1") };
                                                }}
                                                className="form-control number"
                                                placeholder='Enter Mobile No'
                                                value={SaveData.MobileNo}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const mobileNo = value.replace(/[^0-9]/g, '')
                                                    setSaveData({
                                                        ...SaveData, MobileNo: mobileNo
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Address Line1</label>
                                            <input
                                                id="txtAddressLine1"
                                                type="text"
                                                maxLength="200"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtAddressLine2") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Address Line1'
                                                value={SaveData.AddressLine1}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, AddressLine1: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Address Line2</label>
                                            <input
                                                id="txtAddressLine2"
                                                type="text"
                                                maxLength="200"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCashAccounts") };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Address Line2'
                                                value={SaveData.AddressLine2}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, AddressLine2: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("activeCheckbox") };
                                                }}
                                                label='Cash Accounts'
                                                placeholder="Cash Accounts"
                                                maxLength='50'
                                                options={CashAccountsOptionArr}
                                                id='txtCashAccounts'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCashAccounts()}
                                                inputValue={SaveData.CashAccounts ? SaveData.CashAccounts : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, CashAccounts: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnsave") };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.WareHouseID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id="btnsave" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle} handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='WareHouseMaster' />

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default WareHouseMaster